import { useLanguage } from '../../contexts/language';
import { useSession } from '../../contexts/session';

import { Appearance } from '../appearance';
import { ProfileDetails } from '../profile-details';
import { SignOut } from '../sign-out';
import { YourClinicians } from '../your-clinicians';

import styles from './style.module.css';

// Profile & settings, reached from the top bar rather than as a section: the
// profile as onboarding recorded it, the Appearance switch (C27), and Sign
// out. A patient also sees the
// clinicians they are connected with and the invitations waiting for them
// (C22); a clinician has no such list.
export function Settings() {
  const { text } = useLanguage();
  const { me } = useSession();

  let clinicians = null;

  if (me.role === 'PATIENT') {
    clinicians = <YourClinicians/>;
  }

  return (
    <section className={ styles.settings }>
      <h1 className={ styles.title }>{ text.profileAndSettings }</h1>

      <div className={ styles.columns }>
        <div className={ styles.column }>
          <ProfileDetails/>

          <Appearance/>

          <SignOut/>
        </div>

        { clinicians }
      </div>
    </section>
  );
}
